export const PROJECTS_LIST_UPDATE = 'PROJECTS_LIST_UPDATE'

export const PROJECT_PROPS_UPDATE = 'PROJECT_PROPS_UPDATE'
export const PROJECT_PROPS_CLEAR = 'PROJECT_PROPS_CLEAR'

export const PROJECT_ADD_EVENT_ROW = 'PROJECT_ADD_EVENT_ROW'
export const PROJECT_ADD_MILEAGE_REPORT = 'PROJECT_ADD_MILEAGE_REPORT'
export const PROJECT_ADD_TIME_REPORT = 'PROJECT_ADD_TIME_REPORT'
